{
  "title": "Import học viên bằng AI",
  "subtitle": "Tải lên file Excel/CSV danh sách học viên, AI sẽ tự nhận diện các cột",
  "overflowWarning": "File vượt giới hạn {{count}} dòng, chỉ 500 dòng đầu được xử lý. Chia nhỏ file để import phần còn lại.",
  "steps": {
    "upload": "Tải file",
    "mapping": "Kiểm tra cột",
    "preview": "Xem trước",
    "result": "Kết quả"
  },
  "upload": {
    "dropHint": "Kéo thả file vào đây",
    "formats": "Hỗ trợ .xlsx và .csv",
    "browse": "Chọn file",
    "analyzing": "Đang phân tích file...",
    "rejectedFormat": "Chỉ hỗ trợ file .xlsx hoặc .csv",
    "error": "Không thể phân tích file"
  },
  "mapping": {
    "headerRow": "Dòng tiêu đề: dòng {{row}}",
    "payerModeLabel": "Ai là người trả phí?",
    "payerMode": {
      "parent": "Phụ huynh trả phí",
      "self_pay": "Học viên tự trả"
    },
    "fields": {
      "studentName": "Họ và tên",
      "nickname": "Tên thường gọi",
      "dateOfBirth": "Ngày sinh",
      "tags": "Thẻ",
      "payerName": "Tên người trả phí",
      "payerPhone": "SĐT/Zalo người trả phí",
      "payerEmail": "Email người trả phí"
    },
    "selectPlaceholder": "Chọn cột...",
    "none": "(không có)",
    "columnFallback": "Cột {{index}}",
    "reapply": "Áp dụng lại",
    "reapplying": "Đang áp dụng...",
    "next": "Tiếp tục",
    "needStudentName": "Chọn cột Họ và tên để tiếp tục",
    "aiRead": "AI đã đọc file: tiêu đề cột nằm ở dòng {{row}}, có {{count}} dòng dữ liệu.",
    "payerModeHelp": "Chọn “Học viên tự trả” khi file không có cột phụ huynh, ví dụ lớp người lớn tự đóng học phí.",
    "sectionColumns": "Cột thông tin: AI đã tự gán, sửa lại nếu chưa đúng"
  },
  "preview": {
    "ready": "Sẵn sàng ({{count}})",
    "warning": "Có cảnh báo ({{count}})",
    "needsFix": "Thiếu dữ liệu ({{count}})",
    "dupWarning": "Có thể trùng ({{count}})",
    "col": {
      "row": "Dòng",
      "studentName": "Học viên",
      "payer": "Người trả phí",
      "fee": "Học phí",
      "status": "Trạng thái",
      "action": "Thao tác"
    },
    "statusReady": "Sẵn sàng",
    "statusWarning": "Có cảnh báo",
    "statusNeedsFix": "Thiếu dữ liệu",
    "statusDup": "Có thể trùng",
    "studentNamePlaceholder": "Tên học viên",
    "payerNamePlaceholder": "Tên người trả phí",
    "payerPhonePlaceholder": "SĐT/Zalo",
    "exclude": "Bỏ",
    "keepAnyway": "Vẫn thêm",
    "classCapNote": "Nhập vào lớp tối đa 100 học viên một lần.",
    "classCapExceeded": "Đang chọn {{count}} học viên, vượt {{over}} so với mức tối đa 100. Bỏ bớt dòng để tiếp tục.",
    "dupExistingPayer": "Đã có hồ sơ · khách hàng {{name}} ({{phone}})",
    "dupBatchNote": "Trùng với dòng {{row}} trong file",
    "dupUseExisting": "Dùng học viên đã có",
    "dupSkipBatch": "Bỏ qua (trùng trong file)",
    "dupCreateNew": "Tạo mới",
    "empty": "Không có dòng dữ liệu nào",
    "commitError": "Không thể import",
    "back": "Quay lại",
    "willImport": "Sẽ import {{count}} học viên",
    "commit": "Xác nhận import",
    "committing": "Đang import..."
  },
  "result": {
    "title": "Đã import xong",
    "created": "Học viên đã tạo",
    "payersCreated": "Người trả phí mới",
    "payersLinked": "Người trả phí đã liên kết",
    "skipped": "Đã bỏ qua",
    "classSummary": "Đã thêm {{count}} học viên vào {{class}}, {{linked}} em dùng hồ sơ có sẵn, {{skipped}} dòng bỏ qua.",
    "warningsTitle": "{{count}} dòng đã import kèm cảnh báo",
    "warningsHint": "Thường là ngày sinh không đọc được. Mở từng học viên để bổ sung.",
    "errorsTitle": "{{count}} dòng lỗi",
    "errorLine": "Dòng {{row}}: {{reason}}",
    "close": "Đóng"
  }
}
